export default ({ colors }) => {
  const keyframes = {
    firstDot: {
      '0%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '25%': {
        backgroundColor: colors.spinner.dots.opaque
      },

      '50%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '75%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '100%': {
        backgroundColor: colors.spinner.dots.transparent
      }
    },

    middleDot: {
      '0%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '25%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '50%': {
        backgroundColor: colors.spinner.dots.opaque
      },

      '75%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '100%': {
        backgroundColor: colors.spinner.dots.transparent
      }
    },

    lastDot: {
      '0%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '25%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '50%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '75%': {
        backgroundColor: colors.spinner.dots.opaque
      },

      '100%': {
        backgroundColor: colors.spinner.dots.transparent
      }
    }
  }

  const styles = {
    spinner: {
      position: 'fixed',
      zIndex: '120',
      top: '0',

      display: 'block',

      width: '100%',
      height: '100%',

      textAlign: 'center'
    },

    'spinner--global': {
      backgroundColor: colors.spinner.bg.opaque
    },

    'spinner--step': {
      background: colors.spinner.bg.transparent
    },

    'spinner--local': {
      background: 'transparent',
      position: 'absolute'
    },

    'spinner-dots': {
      position: 'absolute',
      top: '50%',
      left: '50%',

      width: '12px',
      height: '12px',
      margin: '-6px 0 0 -6px',

      animationName: keyframes.middleDot,
      animationDuration: '2s',
      animationTimingFunction: 'ease-in-out',
      animationIterationCount: 'infinite',

      borderRadius: '50%',

      '::before': {
        position: 'absolute',
        top: '0',
        left: '-25px',

        width: '12px',
        height: '12px',

        content: '\'\'',

        animationName: keyframes.firstDot,
        animationDuration: '2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',

        borderRadius: '50%'
      },

      '::after': {
        position: 'absolute',
        top: '0',
        left: '25px',

        width: '12px',
        height: '12px',

        content: '\'\'',
        animationName: keyframes.lastDot,
        animationDuration: '2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',

        borderRadius: '50%'
      }
    }
    // 'spinner-dots--local': {
    //   animationName: keyframes.middleDotLocal,
    //   '::before': {
    //     animationName: keyframes.firstDotLocal
    //   },
    //   '::after': {
    //     animationName: keyframes.lastDotLocal
    //   }
    // }
  }

  return styles
}



// WEBPACK FOOTER //
// ./components/spinner/styles.js